import React from "react";
import { cn } from "@/lib/utils";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function StatCard({ label, value, icon: Icon, hint, loading, testId = "dashboard-stat-card" }) {
    return (
        <Card className={cn("rounded-xl border shadow-sm")}
            data-testid={testId}>
            <CardContent className="p-4">
                <div className="flex items-start justify-between">
                    <div>
                        <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                            {label}
                        </div>
                        <div className="mt-2 text-2xl font-semibold tracking-tight">
                            {loading ? <Skeleton className="h-7 w-14" /> : value}
                        </div>
                        {hint && (
                            <div className="mt-1 text-[11px] text-muted-foreground">{hint}</div>
                        )}
                    </div>
                    {Icon && (
                        <div className="rounded-lg bg-muted p-2 text-muted-foreground">
                            <Icon className="h-4 w-4" />
                        </div>
                    )}
                </div>
            </CardContent>
        </Card>
    );
}
